export default __webpack_public_path__ + "static/108135-44cfd1d9769eaf1f83c740fe3d1ce7c8.jpg";